import {requestWX, request, getToken, refreshToken} from "../app/request";

function getWXMP(method, bizContent={}) {
    return request({
        url: '/toodo/tdk/wxmp?token=' + getToken(),
        data: {
            method,
            bizContent
        }
    })
}

//微信网页登录
//输入：微信用户授权标识code
//输出：用户登录信息，包括APP接口用的token
export function getWXLogin(bizContent={}) {
    // return getWXMP('/login', bizContent)
    return getWXMP('/mpWebLogin', bizContent)
}

//app登录接口
function getAppReqLogin(method, bizContent={}) {
    return request({
        url: '/toodo?token=' + getToken(),
        data: {
            method,
            bizContent
        }
    })
}
//app微信网页登录
//输入：
//         identifier,     //唯一标识 手机号或者第三方openid  (string)
//         unionId,        //微信通用标识    (string)
//         headImgUrl,    //微信头像    (string)
//         nickname,       //微信昵称    (string)
//输出：用户登录信息，包括APP接口用的token
export function getAppLogin(bizContent={}) {
    return getAppReqLogin('/wxWebLogin', bizContent)
}

//打开APP-SDK使用权限
//作用： 刷新APP接口token，获取APP-SDK使用权限
//      token由getWXLogin接口获得
export function enableAppSDK(token){
    return refreshToken(token)
}









//=================================================================================
//以下是dany服务接口
//=================================================================================
//微信分享
//获取JS-SDK使用权限签名算法包
/*
* "appId":"wx0436c2e9ea60fce2",
* "nonceStr":"KqeYVlF9IFH5E1Mi",
* "timestamp":1640414229,
* "url":"https:\/\/tddev.toodo.com.cn\/wxp\/wx\/api\/getSignPack",
* "signature":"659a3f7aaf3473ded8ae587349b93e8c6ba6ad9d",
* "errcode":0 （失败非0）
 */
export function getWXSignPack(method='123', bizContent={}) {
    return requestWX({
        url: '/wx/api/getSignPack',
        data: {
            method,
            bizContent
        }
    })
}

//获取带参二维码
export function getWXQrcode(method='123', bizContent={}) {
    return requestWX({
        url: '/wx/public/qrcodeCreate',
        data: {
            method,
            bizContent
        }
    })
}